// AI生视频
import AIImageEditingIndex from '@/views/smartLife/AIImageEditing/index'

const jmRoutes = Array.from({ length: 10 }, (_, i) => ({
  path: `AIImageEditing/jm/index${i + 1}`,
  name: `AIImageEditing/jm/Index${i + 1}`,
  component: () =>
    import(`@/views/smartLife/AIImageEditing/jm/index${i + 1}.vue`)
}))

const dbRoutes = Array.from({ length: 17 }, (_, i) => ({
  path: `AIImageEditing/db/index${i + 1}`,
  name: `AIImageEditing/db/Index${i + 1}`,
  component: () =>
    import(`@/views/smartLife/AIImageEditing/db/index${i + 1}.vue`)
}))
const branch1dbRoutes = Array.from({ length: 7 }, (_, i) => ({
  path: `AIImageEditing/db/branch1/index${i + 1}`,
  name: `AIImageEditing/db/branch1/Index${i + 1}`,
  component: () =>
    import(`@/views/smartLife/AIImageEditing/db/branch1/index${i + 1}.vue`)
}))

export default {
  path: '/smartLife',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'AIImageEditing/index',
      name: 'AIImageEditingIndex',
      component: AIImageEditingIndex
    },
    // AI修图，开始
    ...jmRoutes,
    ...dbRoutes,
    ...branch1dbRoutes
    // AI修图，结束
  ]
}
